// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"trainings_actionsWrapper__K35go","actionLabel":"trainings_actionLabel__s736Q","action":"trainings_action__mTDn2","trainingsList":"trainings_trainingsList__GSwFg"};